import { baseAPIRequest } from 'utilities/http';

import { baseURI } from './config';

async function postAnswer (data) {

	try {

		const url = `${baseURI}/answers/`;
		const response = await baseAPIRequest({
			url,
			data,
			params: { method: 'POST' }
		});

		if (!response.isSuccess) {

			const [ error ] = response.errors;
			throw new Error(`Failed to create answer: ${error.message}`);

		}

		return response;

	} catch (error) {

		// eslint-disable-next-line no-console
		console.error(error.message);
		throw Error;

	}

}

export default postAnswer;
